import type { SoundName } from "@utils/sound/sounds";

export const SOUND_PREF_KEY = "tixu:sound-effects";

/** Sound is on unless the student switched it off. Unreadable storage counts as "on". */
export function readSoundPref(storage: Pick<Storage, "getItem"> | null = defaultStorage()): boolean {
    try {
        return storage?.getItem(SOUND_PREF_KEY) !== "off";
    } catch {
        return true;
    }
}

export function writeSoundPref(enabled: boolean, storage: Pick<Storage, "setItem"> | null = defaultStorage()) {
    try {
        storage?.setItem(SOUND_PREF_KEY, enabled ? "on" : "off");
    } catch {
        // private mode / blocked storage: the in-memory store still holds the choice
    }
}

function defaultStorage(): Storage | null {
    if (typeof window === "undefined") return null;
    try {
        return window.localStorage;
    } catch {
        return null;
    }
}

export function soundForAnswerCheck({ isCorrect }: { isCorrect: boolean }): SoundName {
    return isCorrect ? "correct" : "wrong";
}

/** Completion-flow screens that play a fanfare when they enter. */
export const SCREEN_SOUNDS: Record<string, SoundName> = {
    levelUp: "levelUp",
    courseCompleted: "levelUp"
};

export function soundForCompletionScreen(screen: string | null): SoundName | null {
    if (screen === null) return null;
    return SCREEN_SOUNDS[screen] ?? null;
}

/** Nothing plays in a hidden tab. */
export function canPlay(
    doc: Pick<Document, "visibilityState"> | null = typeof document === "undefined" ? null : document
) {
    return doc === null || doc.visibilityState !== "hidden";
}
